export const LICENSE_TYPE = {
  TRIAL: 'Trial',
  PAID: 'Paid',
  INTERNAL: 'Internal',
} as const;

export const ACCESS_TYPE = {
  ADMIN: 'Admin',
  TEACHER: 'Teacher',
  STUDENT: 'Student',
} as const;
